import React from "react";

function QuesSVG({ open }) {
	return (
		<div>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke-width='1.5'
				stroke='currentColor'
				class={`w-6 h-6 ${open && "rotate-180"}`}
			>
				<path
					stroke-linecap='round'
					stroke-linejoin='round'
					d='m19.5 8.25-7.5 7.5-7.5-7.5'
				/>
			</svg>
		</div>
	);
}

export default QuesSVG;
